import React, {useState} from 'react'

// Components
// import FacebookLoginButton from '../elements/FacebookLoginButton'
import GoogleLoginButton from '../elements/GoogleLoginButton'
import config from '../../api/config'

function SocialMediaButtons(props) {
    const [errors, setErrors] = useState("")

    if (!config.googleAppId) return null

    const handleError = (error) => {
        if(error){
            setErrors(error);
        }
    }

    return (
        <div className="social-buttons-container">
            <div className="rule-with-text social-buttons-separator">OR</div>
            <GoogleLoginButton type={props.type} redirectPath={props.redirectPath} onErrorRequest={handleError}/>
            {/* <FacebookLoginButton type={props.type} onErrorRequest={handleError}/> */}
            <p className="error">{errors}</p>
        </div>
    )
}

export default SocialMediaButtons
